import T from 'prop-types';
import React from 'react';
import { Button } from '@acast/decibel';

import FileUploadButton from './with-file-uploader';

function NewEpisodeButton(props) {
  return (
    <FileUploadButton disabled={props.disabled} showId={props.showId}>
      {({ disabled, loading, onClick }) => (
        <Button
          className="new-episode-button"
          variant="primary"
          size="small"
          onClick={onClick}
          disabled={disabled}
          busy={loading}
        >
          New Episode
        </Button>
      )}
    </FileUploadButton>
  );
}

NewEpisodeButton.propTypes = {
  disabled: T.bool,
  showId: T.string,
};

export default NewEpisodeButton;
